
export default function ProgettiSection() {
  const projects = [
    {
      title: 'Residenza Verde Trastevere',
      category: 'Residenziale',
      year: '2023',
      desc: 'Riqualificazione di un palazzo storico con giardini verticali, isolamento in fibra di canapa e sistema di raccolta acque piovane.',
      image: 'https://public.readdy.ai/ai/img_res/85758da6ded6e6e97271b79aba6f90ee.jpg',
      stats: [
        { label: 'Riduzione CO\u2082', value: '72%' },
        { label: 'Classe Energetica', value: 'A+++' },
      ],
    },
    {
      title: 'Centro Direzionale Bio-Climatico',
      category: 'Commerciale',
      year: '2022',
      desc: 'Edificio per uffici con ventilazione naturale incrociata, tetto verde di 2000m\u00B2 e pannelli fotovoltaici integrati nella facciata.',
      image: 'https://readdy.ai/api/search-image?query=contemporary%20commercial%20office%20building%20with%20bioclimatic%20design%20features%2C%20large%20glass%20facade%20with%20wooden%20brise%20soleil%20shading%2C%20extensive%20green%20roof%20garden%20visible%20from%20street%20level%2C%20integrated%20photovoltaic%20panels%20on%20south%20facade%2C%20people%20walking%20near%20entrance%2C%20Mediterranean%20urban%20setting%2C%20professional%20architectural%20photography%20with%20dramatic%20sky&width=700&height=500&seq=proj-office-bio-v3&orientation=landscape',
      stats: [
        { label: 'Risparmio Energetico', value: '85%' },
        { label: 'Tetto Verde', value: '2000m\u00B2' },
      ],
    },
    {
      title: 'Parco Urbano Respirante',
      category: 'Spazio Pubblico',
      year: '2024',
      desc: "Progettazione di un'area pubblica con pavimentazione drenante, vegetazione autoctona e microclimi urbani per il benessere dei cittadini.",
      image: 'https://readdy.ai/api/search-image?query=modern%20urban%20park%20design%20with%20permeable%20paving%2C%20native%20Mediterranean%20plants%20and%20trees%2C%20wooden%20seating%20areas%2C%20water%20features%20with%20recycled%20rainwater%2C%20families%20enjoying%20the%20green%20space%2C%20sustainable%20landscape%20architecture%2C%20warm%20afternoon%20sunlight%20filtering%20through%20olive%20trees%2C%20professional%20landscape%20photography&width=700&height=500&seq=proj-park-urban-v3&orientation=landscape',
      stats: [
        { label: 'Area Verde', value: '5000m\u00B2' },
        { label: 'Specie Autoctone', value: '45+' },
      ],
    },
    {
      title: 'Villa Passiva sul Lago',
      category: 'Residenziale',
      year: '2021',
      desc: 'Villa a consumo quasi zero con pareti in terra cruda, serramenti in legno certificato e sistema geotermico per il riscaldamento.',
      image: 'https://readdy.ai/api/search-image?query=stunning%20passive%20house%20villa%20by%20an%20Italian%20lake%2C%20modern%20minimalist%20architecture%20with%20large%20floor%20to%20ceiling%20windows%20reflecting%20water%2C%20natural%20rammed%20earth%20walls%2C%20certified%20wood%20cladding%2C%20flat%20green%20roof%20blending%20with%20hillside%2C%20serene%20morning%20light%2C%20mountains%20in%20background%2C%20professional%20luxury%20real%20estate%20photography&width=700&height=500&seq=proj-villa-lago-v3&orientation=landscape',
      stats: [
        { label: 'Consumo', value: 'Quasi Zero' },
        { label: 'Materiali Locali', value: '98%' },
      ],
    },
    {
      title: 'Scuola Ecologica Municipale',
      category: 'Istituzionale',
      year: '2023',
      desc: 'Scuola elementare costruita interamente con materiali naturali, aule con luce naturale ottimizzata e cortile didattico con orto botanico.',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20ecological%20elementary%20school%20building%20made%20with%20natural%20sustainable%20materials%2C%20large%20panoramic%20windows%20flooding%20classrooms%20with%20natural%20light%2C%20exposed%20wooden%20structure%20and%20warm%20timber%20cladding%2C%20educational%20botanical%20garden%20courtyard%20with%20vegetable%20beds%20and%20fruit%20trees%2C%20children%20outdoor%20learning%20area%20with%20wooden%20benches%2C%20green%20roof%20with%20native%20plants%2C%20Mediterranean%20setting%20with%20blue%20sky%2C%20professional%20architectural%20photography%20warm%20inviting%20atmosphere&width=700&height=500&seq=proj-scuola-eco-v4&orientation=landscape',
      stats: [
        { label: 'Luce Naturale', value: '100%' },
        { label: 'Orto Didattico', value: '300m\u00B2' },
      ],
    },
    {
      title: 'Cantina Vinicola Sostenibile',
      category: 'Agricolo',
      year: '2020',
      desc: 'Cantina ipogea scavata nella collina tufacea, con climatizzazione naturale, tetto verde praticabile e integrazione totale nel paesaggio.',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20underground%20wine%20cellar%20built%20into%20Italian%20hillside%2C%20green%20roof%20blending%20with%20vineyard%20landscape%2C%20natural%20tufa%20stone%20entrance%2C%20modern%20minimalist%20design%20integrated%20into%20rolling%20Tuscan%20hills%2C%20grapevines%20growing%20on%20roof%2C%20warm%20sunset%20light%2C%20professional%20architectural%20photography%20showing%20building%20landscape%20integration&width=700&height=500&seq=proj-cantina-v3&orientation=landscape',
      stats: [
        { label: 'Climatizzazione', value: 'Naturale' },
        { label: 'Integrazione', value: '100%' },
      ],
    },
  ];

  return (
    <section id="progetti" className="py-16 md:py-32 bg-[#f5f2ee]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-16 gap-4">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
              <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
                Portfolio
              </span>
            </div>
            <h2 className="font-playfair text-[32px] md:text-[52px] font-bold text-[#2d3e40] leading-[1.15]">
              Progetti che{' '}
              <em className="text-[#6b8e7f] not-italic">Respirano</em>
            </h2>
          </div>
          <p className="font-montserrat text-[13px] md:text-[14px] text-[#2d3e40]/60 max-w-[400px] leading-[1.8] md:text-right">
            Ogni progetto racconta una storia di innovazione, rispetto per
            l&apos;ambiente e armonia tra uomo e natura.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {projects.map((project, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.1)] transition-all duration-500 group cursor-pointer"
            >
              <div className="relative w-full h-[220px] sm:h-[260px] md:h-[300px] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4 flex gap-2">
                  <span className="bg-white/90 backdrop-blur-sm text-[#2d3e40] font-montserrat text-[10px] md:text-[11px] uppercase tracking-[1px] px-3 py-1.5 rounded-md font-medium">
                    {project.category}
                  </span>
                  <span className="bg-[#6b8e7f]/90 backdrop-blur-sm text-white font-montserrat text-[10px] md:text-[11px] uppercase tracking-[1px] px-3 py-1.5 rounded-md">
                    {project.year}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-8">
                <h3 className="font-playfair text-[20px] md:text-[24px] font-bold text-[#2d3e40] mb-2 md:mb-3 group-hover:text-[#6b8e7f] transition-colors duration-400">
                  {project.title}
                </h3>
                <p className="font-montserrat text-[13px] md:text-[14px] text-[#2d3e40]/60 leading-[1.8] mb-4 md:mb-6">
                  {project.desc}
                </p>
                <div className="flex items-center gap-4 md:gap-6 pt-4 md:pt-5 border-t border-[#2d3e40]/8">
                  {project.stats.map((stat, j) => (
                    <div key={j}>
                      <span className="block font-playfair text-[17px] md:text-[20px] font-bold text-[#6b8e7f]">
                        {stat.value}
                      </span>
                      <span className="block font-montserrat text-[10px] md:text-[11px] text-[#2d3e40]/50 uppercase tracking-[1px]">
                        {stat.label}
                      </span>
                    </div>
                  ))}
                  <div className="ml-auto w-9 h-9 md:w-10 md:h-10 rounded-full border border-[#6b8e7f]/30 flex items-center justify-center group-hover:bg-[#6b8e7f] group-hover:border-[#6b8e7f] transition-all duration-400">
                    <i className="ri-arrow-right-up-line text-[#6b8e7f] group-hover:text-white transition-colors duration-400"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
